import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, HoverText, CircleBadge } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import who2 from '@/assets/images/IBON-World-Launch-5.jpeg'

export const WhoWeAre = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
        {/* Large sharp-cornered image with floating rotating badge */}
        <Reveal variant="left" duration={750} className="relative">
          <img
            src={who2}
            alt="Cultural celebration at the IBON World launch in Accra, Ghana"
            className="aspect-4/5 w-full object-cover"
            loading="lazy"
          />
          <CircleBadge className="absolute -right-8 -bottom-8 hidden rounded-full bg-white shadow-lg lg:grid" />
        </Reveal>

        {/* Text */}
        <div>
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 max-w-xl text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Building Connections.{' '}
              <span className="text-ibon-dark/30">Creating Opportunities.</span>
            </h2>
          </Reveal>

          <Reveal variant="up" delay={200}>
            <div className="mt-8 max-w-xl space-y-5 text-lg leading-relaxed text-text-muted">
              <p>
                The International Business and Opportunity Network (IBON World) works at the
                intersection of{' '}
                <span className="font-semibold text-ibon-dark">
                  entrepreneurship, education, and cultural exchange.
                </span>
              </p>
              <p>
                We create practical programmes that bring together students, entrepreneurs,
                educators, institutions, and community leaders to learn from one another,
                collaborate across borders, and develop solutions to shared challenges.
              </p>
              <p>
                Our work focuses on helping people gain the knowledge, connections, and confidence
                needed to create opportunities for themselves and contribute to the development of
                their communities.
              </p>
            </div>
          </Reveal>

          <Reveal variant="up" delay={360}>
            <NavLink
              to={ROUTES.ABOUT}
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-ibon-dark px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-ibon-navy"
            >
              <HoverText text="Learn More About Us" />
              <FiArrowRight
                className="transition-transform duration-300 group-hover:translate-x-1"
                size={15}
              />
            </NavLink>
          </Reveal>
        </div>
      </Container>
    </section>
  )
}
